import { createStore, combineReducers } from 'redux';
import { appReducer, employeeOrderConfigReducer, orderDataReducer, employeeRecruitmentConfigReducer } from './redux-reducers';
import { loadState, saveState } from './local-storage';

const rootReducer = combineReducers({
  app: appReducer,
  employeeOrderConfig: employeeOrderConfigReducer,
  orderData: orderDataReducer,
  employeeRecruitmentConfig: employeeRecruitmentConfigReducer
});
const store = createStore(rootReducer, loadState());

store.subscribe(saveState);

export default store;
